import type { ReactNode } from "react";

/** Shared `<svg>` wrapper for the app's icon set. `size` defaults to the
 * existing 16px used everywhere today — the 87 `*Icon.tsx` components that
 * render through this don't need to change; only a caller that wants a
 * bigger glyph (the 40px tool rail, UI redesign phase 3) passes it. */
export function Icon({ children, size = 16 }: { children: ReactNode; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </svg>
  );
}
